import mutations from '@/store/modules/channel/overview/overview.mutations';
import actions from '@/store/modules/channel/overview/overview.actions';
import getters from '@/store/modules/channel/overview/overview.getters';

export interface State {
  currentChannel: {};
  channels: {}[];
  totalChannels: Number;
  searchTotalChannels: Number;
  showAddChannel: Boolean;
  showDeleteChannel: Boolean;
  refreshChannels: Boolean;
  alertRuleChannels: {}[];
  alertGroupRuleChannels: Array<string>;
  totalAlertRuleChannels: Number;
}

export const initialState: State = {
  currentChannel: {},
  channels: [],
  totalChannels: 0,
  searchTotalChannels: 0,
  showAddChannel: false,
  showDeleteChannel: false,
  refreshChannels: false,
  alertRuleChannels: [],
  alertGroupRuleChannels: [],
  totalAlertRuleChannels: 0
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
